import { Injectable, TemplateRef } from '@angular/core';
import {
  Label,
  Project,
  ShiftColorOptions,
  TimelineShift,
} from '@wilson/interfaces';

export interface UnassignedShiftCardCellViewPreviewContext {
  shift: Pick<TimelineShift, 'name' | 'shiftCategoryId'>;
  shiftColorOption: ShiftColorOptions;
  label: Label | null;
  project: Project | null;
  shiftCategoryId: string | null;
  hasProjectReadPermission: boolean;
  showShiftValidation: boolean;
  hasShiftBeenValidated: boolean;
  isLoadingValidations: boolean;
  isLoadingValidationsError: boolean;
  isShiftValid: boolean;
  isShiftModified: boolean;
  width: number;
  loadIconsImmediately: boolean;
  isShiftSelected: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DeferredUnassignedShiftCardCellViewHelperService {
  private previewTemplate: TemplateRef<UnassignedShiftCardCellViewPreviewContext> | null =
    null;
  private previewTemplateContent: TemplateRef<
    Partial<UnassignedShiftCardCellViewPreviewContext>
  > | null = null;

  setPreviewTemplate(
    template: TemplateRef<UnassignedShiftCardCellViewPreviewContext>,
  ): void {
    this.previewTemplate = template;
  }

  getPreviewTemplate(): TemplateRef<UnassignedShiftCardCellViewPreviewContext> | null {
    return this.previewTemplate;
  }

  setPreviewTemplateContent(
    template: TemplateRef<Partial<UnassignedShiftCardCellViewPreviewContext>>,
  ): void {
    this.previewTemplateContent = template;
  }

  getPreviewTemplateContent(): TemplateRef<
    Partial<UnassignedShiftCardCellViewPreviewContext>
  > | null {
    return this.previewTemplateContent;
  }

  clearReferences() {
    this.previewTemplate = null;
    this.previewTemplateContent = null;
  }
}
